export const isLoggedIn = state => !!state.token
export const authStatus = state => state.status
export const userRole = state => state.userRole
export const userSocieteId = state => state.userSocieteId
export const userId = state => state.userId
export const expireDate = state => state.expireDate
export const firstName = state => state.firstName
export const name = state => state.name
export const societeNom = state => state.societeNom
export const societeLists = state => state.societeLists



// WEBPACK FOOTER //
// ./src/store/modules/login/getters.js